/* unplugin-vue-components disabled */import { render } from "./SearchChips.vue?vue&type=template&id=26e174cb&scoped=true"
import script from "./SearchChips.vue?vue&type=script&lang=js"
export * from "./SearchChips.vue?vue&type=script&lang=js"

import "./SearchChips.vue?vue&type=style&index=0&id=26e174cb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26e174cb"]])

export default __exports__